import React from 'react';

import {
    Anchor,
    Flex,
    Image,
    Spacer,
} from '@zillow/constellation';

import { StyledCenterText } from 'app/shared/StyledComponents/StyledComponents';

import PersonProfile from 'app/shared/images/PersonProfile.svg';

import { StyledDialogBodyContainer } from 'app/shared/containers/ModalContainer/StyledComponents';

import { StyledIconContainer } from './StyledComponents';

const propTypes = {};

const defaultProps = {};

const FeedListingDeactivateConfirmationModal = () => (
    <StyledDialogBodyContainer className="FeedListingDeactivateConfirmationModal">
        <Flex
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Spacer marginY="xs">
                <StyledIconContainer>
                    <Image src={PersonProfile} alt="person" />
                </StyledIconContainer>
            </Spacer>

            <StyledCenterText as="p" fontType="body">
                This listing will be deactivated as of today.
                Your advertising period will be included on your next invoice.
            </StyledCenterText>

            <Spacer paddingBottom="xs" />

            <StyledCenterText as="p" fontType="body">
                If you’re unsatisfied with our service, we want to hear how we can help.&nbsp;
                Please email&nbsp;
                <Anchor
                    as="a"
                    href="mailto:rentalshelp@zillowgroup.com"
                >
                    rentalshelp@zillowgroup.com
                </Anchor>
            </StyledCenterText>
            <Spacer paddingBottom="sm" />
        </Flex>
    </StyledDialogBodyContainer>
);

FeedListingDeactivateConfirmationModal.propTypes = propTypes;
FeedListingDeactivateConfirmationModal.defaultProps = defaultProps;

export default FeedListingDeactivateConfirmationModal;
